import { FilterType } from '~/client/graph'

const GroupingOption = {
  None: 'none',
  Wbs: 'wbs',
  Lbs: 'lbs',
  Building: FilterType.Building,
  Level: FilterType.Level,
  Zone: FilterType.Zone,
  Company: FilterType.Company,
  Equipment: 'equipment',
  VerticalObject: 'verticalObject',
  Route: 'route',
  Gate: 'gate',
}

export default GroupingOption
